import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * EmptyState — reusable empty / zero-data placeholder.
 *
 * Props:
 *   icon      string  emoji or small SVG (default "📭")
 *   title     string  short heading
 *   message   string  supporting copy
 *   action    string  button label (optional)
 *   actionPath string  navigate path on button click (optional)
 *   inline    bool    compact horizontal layout (default false)
 */
const EmptyState = ({
  icon = '📭',
  title,
  message,
  action,
  actionPath,
  inline = false,
}) => {
  const navigate = useNavigate();

  return (
    <div className={`empty-state${inline ? ' empty-state--inline' : ''}`}>
      <span className="empty-state__icon">{icon}</span>
      {!inline && title && <p className="empty-state__title">{title}</p>}
      {message && <p className="empty-state__message">{message}</p>}
      {action && actionPath && !inline && (
        <div className="empty-state__action">
          <button
            className="btn btn-primary"
            onClick={() => navigate(actionPath)}
          >
            {action}
          </button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
